// extracted by mini-css-extract-plugin
module.exports = {"container":"TrainSHomeJourneyType_container__3BE9c","type":"TrainSHomeJourneyType_type__1Yg4M","active":"TrainSHomeJourneyType_active__3_zJY"};